const env = {
  development: {
     API_URL: 'https://api.masar.tech',
    //API_URL: 'https://betabackend.secure.masar.tech',
    //API_URL: 'http://192.168.100.3:3000',
  },
  production: {
   API_URL: 'https://api.masar.tech',
  // API_URL: 'https://api.masar.tech',
    //API_URL: 'https://betabackend.secure.masar.tech',
   // API_URL: 'http://192.168.18.48:3000',
  },
};

const enviroment =
  process.env.NODE_ENV === 'development' ? env.development : env.production;

export default { ...enviroment };



// WEBPACK FOOTER //
// ./src/defaults/env.js